import { PrimitiveTypeName } from "../types";
import { not } from "./operators";

export const isType = (type: PrimitiveTypeName) => (value: unknown) =>
    typeof value === type;

export const isString = isType("string");
export const isNumber = isType("number");
export const isBoolean = isType("boolean");
export const isObject = isType("object");
export const isSymbol = isType("symbol");
export const isBigInt = isType("bigint");
export const isFunction = isType("function");
export const isUndefined = isType("undefined");

export const isNotString = not(isString);
